export type ComponentFamily = 'BAIC' | 'CSAI' | 'MAI' | 'A8';

/** The set of values the Deploy & Upgrade Type column/chip filter can show -
 * the four catalog families plus the two non-deployable buckets (Infra,
 * and anything unresolved). Distinct from ComponentFamily, which is used
 * wherever a value must be an actually-deployable family (e.g.
 * canDeployFamily/onDeployFamily). */
export type DisplayFamily = ComponentFamily | 'Infra' | 'Others';

export const FAMILY_OPTIONS: { value: DisplayFamily; label: string }[] = [
  { value: 'BAIC', label: 'BAIC' },
  { value: 'CSAI', label: 'CSAI' },
  { value: 'MAI', label: 'MAI' },
  { value: 'A8', label: 'A8' },
  { value: 'Infra', label: 'Infra' },
  { value: 'Others', label: 'Others' },
];

/**
 * Maps a raw ResolveComponentFamiliesResponse family value to a display
 * label. Backend values are lowercase catalog families (baic/mai/csai/a8),
 * plus "infra" for third-party platform infrastructure (Temporal, Flyte -
 * see familyOverrides in internal/management/backstage/client.go), mapped to
 * the "Infra" chip. Anything unresolved (missing from the RPC's response
 * map) falls back to "Others" so every deployed component always has a
 * Type/chip home - never a silent gap.
 */
export function displayFamily(rawFamily: string | undefined): DisplayFamily {
  switch (rawFamily) {
    case 'baic':
      return 'BAIC';
    case 'csai':
      return 'CSAI';
    case 'mai':
      return 'MAI';
    case 'a8':
      return 'A8';
    case 'infra':
      return 'Infra';
    default:
      return 'Others';
  }
}

/** Narrows a DisplayFamily down to a deployable ComponentFamily - Infra and
 * Others are never deployable, so canDeployFamily/onDeployFamily must never
 * be called with them. */
export function isComponentFamily(value: DisplayFamily | null): value is ComponentFamily {
  return value === 'BAIC' || value === 'CSAI' || value === 'MAI' || value === 'A8';
}
